import axios from '../utils/axiosClient';
import endpoints from './endpoints';

const { getDataDetails, getExchangeRates, getPublicSettings, getPublicAuthUserSettings } = endpoints;

const getDetails = async () => {
  try {
    const response = await axios.get(getDataDetails);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const getExchRates = async () => {
  try {
    const response = await axios.get(getExchangeRates);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const getPublicSettingsData = async () => {
  try {
    const response = await axios.get(getPublicSettings);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const getPublicAuthUserSettingsData = async () => {
  try {
    const response = await axios.get(getPublicAuthUserSettings);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const dataServices = {
  getDetails,
  getExchRates,
  getPublicSettingsData,
  getPublicAuthUserSettingsData,
};

export default dataServices;
